/**
 * The one way an empty value looks. A blank cell is indistinguishable from a
 * rendering bug; a dash says "there is nothing here" on purpose. The dash itself
 * is decoration, so the meaning is carried by text a screen reader can read.
 */
export function EmptyValue() {
  return (
    <span className="text-ink-subtle">
      <span aria-hidden="true">&ndash;</span>
      <span className="sr-only">empty</span>
    </span>
  );
}
